import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings";
import UserSettingsViewsBoard from "./board";
import UserSettingsViewsMyCalendar from "./my-calendar";
import UserSettingsViewsMyWork from "./my-work";
import UserSettingsViewsTaskList from "./task-list";
import UserSettingsViewsGantt from "./gantt";
import UserSettingsViewsWorkload from "./workload";
import UserSettingsUsersManagement from "./users-management";
import UserSettingsViewsNotepad from "./notepad";
import UserSettingsViewsNotifications from "./notifications";
import UserSettingsViewsChat from "./chat";
import UserSettingsViewsGoals from "./goals"
import UserSettingsViewsSavedReports from "./saved-reports";
import UserSettingsViewsArchivedProjectsView from "./archived-projects-view"
import UserSettingsViewsCRMProjectsView from "./crm-projects-view"

const fieldsConfig = {

    notepad    : {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsNotepad
    },
    chat    : {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsChat
    },
    taskView    : {
        type            : ServerSettingsFieldType.VALUE,
    },

    myTime    : {
        type            : ServerSettingsFieldType.VALUE,
    },

    'board': {
        type            : 'class',
        class           : UserSettingsViewsBoard,
    },

    'myWork': {
        type            : 'class',
        class           : UserSettingsViewsMyWork
    },

    'notifications': {
        type            : 'class',
        class           : UserSettingsViewsNotifications
    },

    'myCalendar': {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsMyCalendar,
    },

    'taskList': {
        type            : 'class',
        class           : UserSettingsViewsTaskList
    },

    'gantt': {
        type            : 'class',
        class           : UserSettingsViewsGantt
    },

    'workload': {
        type            : 'class',
        class           : UserSettingsViewsWorkload
    },

    'usersManagement': {
        type            : 'class',
        class           : UserSettingsUsersManagement
    },

    'autoSave'  : {
        type            : 'value',
        defaultValue    : true
    },

    goals    : {
        type            : 'class',
        class           : UserSettingsViewsGoals
    },

    rightClickMoreMenu  : {
        type            : 'value',
        defaultValue    : true
    },

    savedReports    : {
        type            : 'class',
        class           : UserSettingsViewsSavedReports
    },

    crmProjects     : {
        type            : 'class',
        class           : UserSettingsViewsCRMProjectsView
    },

    archivedProjects: {
        type            : 'class',
        class           : UserSettingsViewsArchivedProjectsView
    },
}

export default class UserSettingsViews extends ServerSettings {

    public board                : UserSettingsViewsBoard
    public notepad              : UserSettingsViewsNotepad
    public chat                 : UserSettingsViewsChat
    public myWork               : UserSettingsViewsMyWork
    public notifications        : UserSettingsViewsNotifications
    public myCalendar           : UserSettingsViewsMyCalendar
    public taskList             : UserSettingsViewsTaskList
    public gantt                : any
    public workload             : any
    public usersManagement      : any
    public autoSave             : any   // boolean ???
    public taskView             : any // we work with it from taskView.settings
    public myTime               : any
    public goals                : UserSettingsViewsGoals
    public rightClickMoreMenu   : boolean
    public savedReports         : UserSettingsViewsSavedReports
    public crmProjects          : UserSettingsViewsCRMProjectsView
    public archivedProjects     : UserSettingsViewsArchivedProjectsView

    constructor(config: any) {

        super(config, fieldsConfig);

        this.notepad            = this.initValue('notepad')
        this.chat               = this.initValue('chat')
        this.taskView           = this.initValue('taskView')
        this.board              = this.initValue('board')
        this.myWork             = this.initValue('myWork')
        this.notifications      = this.initValue('notifications')
        this.myCalendar         = this.initValue('myCalendar')
        this.taskList           = this.initValue('taskList')
        this.gantt              = this.initValue('gantt')
        this.workload           = this.initValue('workload')
        this.usersManagement    = this.initValue('usersManagement')
        this.myTime             = this.initValue('myTime')
        this.goals              = this.initValue('goals')

        // auto save current views when change
        this.autoSave           = this.initValue('autoSave')

        // Table/List/Board/Gantt item right click show more menu
        this.rightClickMoreMenu = this.initValue('rightClickMoreMenu')

        this.savedReports       = this.initValue('savedReports')
        this.crmProjects        = this.initValue('crmProjects')
        this.archivedProjects   = this.initValue('archivedProjects')
    }


    toJson() {

        const result = {};

        this.valueToJson(result, 'myTime')
        this.valueToJson(result, 'notepad')
        this.valueToJson(result, 'chat')
        this.valueToJson(result, 'taskView')
        this.valueToJson(result, 'board')
        this.valueToJson(result, 'myWork')
        this.valueToJson(result, 'notifications')
        this.valueToJson(result, 'myCalendar')
        this.valueToJson(result, 'taskList')
        this.valueToJson(result, 'gantt')
        this.valueToJson(result, 'workload')
        this.valueToJson(result, 'usersManagement')
        this.valueToJson(result, 'autoSave')
        this.valueToJson(result, 'goals')
        this.valueToJson(result, 'rightClickMoreMenu')
        this.valueToJson(result, 'savedReports')
        this.valueToJson(result, 'crmProjects')
        this.valueToJson(result, 'archivedProjects')

        return result;
    }
}
